import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import "typeface-roboto";
import App from "./App";
import { unregister } from "./registerServiceWorker";
import { Provider } from "react-redux";
import store from "./App/Redux/store";

ReactDOM.render(
  <Provider store={store}>
    <App perPage={20} />
  </Provider>,
  document.getElementById("root")
);
unregister();
